// extracted by mini-css-extract-plugin
module.exports = {"icon":"icons-module--icon--3nouu"};